import { money } from "@/lib/format";
import { Check } from "lucide-react";

const SECTIONS = [["company_intro", "Presentación de la empresa"], ["client_need", "Necesidad del cliente"], ["objectives", "Objetivos"],
  ["scope", "Alcance"], ["deliverables", "Entregables"], ["timeline", "Cronograma"], ["payment_terms", "Forma de pago"],
  ["renewals", "Renovaciones"], ["not_included", "Servicios no incluidos"], ["conditions", "Condiciones"], ["next_steps", "Próximos pasos"]];
export const CONTENT_FIELDS = [["cover_title", "Portada (título)"], ...SECTIONS];
export const planText = (pp) => (pp?.mode !== "split" ? "Un solo pago del 100% al aceptar"
  : pp.deposit_type === "amount" ? `Anticipo de ${money(pp.deposit_amount)} al aceptar y el saldo al entregar el proyecto`
    : `${pp.deposit_percent}% de anticipo al aceptar y ${100 - pp.deposit_percent}% al entregar el proyecto`);

export function ProposalDocument({ proposal, version, selectable, selected, onSelect }) {
  const v = version || proposal.versions[proposal.versions.length - 1];
  const c = v.content || {};
  return (
    <article className="card-box print-area overflow-hidden" data-testid="proposal-document">
      <header className="bg-[#0F172A] px-6 py-10 text-white sm:px-10">
        <p className="text-xs uppercase tracking-[0.2em] text-blue-300">RinoTECH · Propuesta {proposal.number} · Versión {v.version}</p>
        <h2 className="mt-3 font-display text-3xl font-extrabold">{c.cover_title || proposal.title}</h2>
        <p className="mt-2 text-sm text-slate-400">Preparada para {proposal.client_name}</p>
      </header>
      <div className="space-y-6 px-6 py-8 sm:px-10">
        {SECTIONS.slice(0, 6).map(([k, l]) => <Block key={k} label={l} text={c[k]} />)}
        <div>
          <h3 className="mb-3 text-sm font-bold uppercase tracking-wide text-slate-500">Inversión</h3>
          <div className={`grid gap-4 ${v.options.length > 1 ? "md:grid-cols-3" : "md:max-w-md"}`}>
            {v.options.map((o) => {
              const isSel = selected === o.key;
              const canPick = selectable && o.total != null;
              return (
                <div key={o.key} onClick={() => canPick && onSelect(o.key)} role={selectable ? "radio" : undefined} aria-checked={selectable ? isSel : undefined} aria-disabled={selectable && !canPick}
                  tabIndex={selectable ? 0 : undefined} onKeyDown={(e) => canPick && (e.key === "Enter" || e.key === " ") && onSelect(o.key)}
                  data-testid={`proposal-option-${o.key}`}
                  className={`relative flex flex-col rounded-lg border-2 p-5 transition-[border-color,box-shadow] duration-150 ${isSel ? "border-blue-600 shadow-md" : o.recommended ? "border-blue-200" : "border-slate-200"} ${canPick ? "cursor-pointer hover:border-blue-400" : selectable ? "cursor-not-allowed opacity-70" : ""}`}>
                  {o.recommended && <span className="absolute -top-2.5 left-4 rounded-full bg-blue-600 px-2 py-0.5 text-[10px] font-bold uppercase text-white">Recomendada</span>}
                  {isSel && <Check className="absolute right-3 top-3 h-5 w-5 text-blue-600" />}
                  <h4 className="font-display text-lg font-bold text-slate-900">{o.name}</h4>
                  <p className="mt-1 text-xs text-slate-500">{o.description}</p>
                  <p className="num my-4 text-2xl font-semibold text-slate-900" data-testid={`proposal-option-total-${o.key}`}>{money(o.total)}</p>
                  {selectable && !canPick && <p className="-mt-2 mb-3 text-xs text-amber-700" data-testid={`proposal-option-unpriced-${o.key}`}>Precio por confirmar: solicite cambios para cotizar esta opción.</p>}
                  <ul className="space-y-1.5 text-sm">
                    {o.items.map((i, idx) => (
                      <li key={idx} className="flex justify-between gap-2"><span>{i.quantity !== 1 && `${i.quantity} × `}{i.name}</span><span className="num shrink-0 text-xs text-slate-500">{money(i.unit_price)}</span></li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
          {v.options.some((o) => o.total == null) && <p className="mt-2 text-xs text-slate-400">[PENDIENTE] indica precios aún no definidos en el catálogo.</p>}
          <p className="mt-4 rounded-md bg-blue-50 px-4 py-3 text-sm text-blue-900" data-testid="proposal-payment-plan"><b>Plan de pago:</b> {planText(proposal.payment_plan)}</p>
        </div>
        {SECTIONS.slice(6).map(([k, l]) => <Block key={k} label={l} text={c[k]} />)}
      </div>
    </article>
  );
}

const Block = ({ label, text }) => (
  <div>
    <h3 className="mb-1.5 text-sm font-bold uppercase tracking-wide text-slate-500">{label}</h3>
    <p className="whitespace-pre-wrap text-sm leading-relaxed text-slate-700">{text || "[PENDIENTE]"}</p>
  </div>
);
